import React, { useReducer } from 'react';
import axios from 'axios';
import ProductContext from './productContext';
import productReducer from './productReducer';

const ProductState = props => {
    const initialState = {
        products: [],
        current: null,
        loading: true,
        error: null
    };

    const [state, dispatch] = useReducer(productReducer, initialState);

    // Get Products by Menu ID
    const getProductsByMenu = async menuId => {
        try {
            const res = await axios.get(`/api/products/menu/${menuId}`);

            dispatch({
                type: 'GET_PRODUCTS',
                payload: res.data
            });
        } catch (err) {
            dispatch({
                type: 'PRODUCT_ERROR',
                payload: err.response?.data?.msg || err.message || 'Ürün işlemi sırasında bir hata oluştu'
            });
        }
    };

    // Add Product to General Catalog
    const addProduct = async product => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        try {
            const res = await axios.post('/api/products', product, config);
            return res.data; // Yeni oluşturulan ürünü döndür
        } catch (err) {
            dispatch({
                type: 'PRODUCT_ERROR',
                payload: err.response?.data?.msg || err.message || 'Ürün işlemi sırasında bir hata oluştu'
            });
            throw err; // Hatanın çağrıldığı yerde yakalanabilmesi için fırlat
        }
    };

    // Add Product to Menu (Link)
    const addProductToMenu = async (menuId, productId) => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        try {
            await axios.post('/api/products/menu', { menu_id: menuId, product_id: productId }, config);
            // Burada state güncellemesi yapmak yerine, ürünleri yeniden çekmek daha mantıklı olabilir
            getProductsByMenu(menuId);
        } catch (err) {
            dispatch({
                type: 'PRODUCT_ERROR',
                payload: err.response?.data?.msg || err.message || 'Ürün işlemi sırasında bir hata oluştu'
            });
            throw err;
        }
    };

    // Delete Product from Menu
    const deleteProductFromMenu = async (menuId, productId) => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
            data: { menu_id: menuId, product_id: productId }
        };

        try {
            await axios.delete('/api/products/menu', config);
            
            // State'den çıkar
            dispatch({
                type: 'DELETE_PRODUCT',
                payload: productId // Not: Bu sadece o anki listeden çıkarır, veritabanından silmez (ki istediğimiz bu)
            });
        } catch (err) {
            dispatch({
                type: 'PRODUCT_ERROR',
                payload: err.response?.data?.msg || err.message || 'Ürün işlemi sırasında bir hata oluştu'
            });
        }
    };

    // Delete Product Permanently
    const deleteProductPermanently = async (productId) => {
        try {
            await axios.delete(`/api/products/${productId}`);
            
            // State'den çıkar (Eğer listede varsa)
            dispatch({
                type: 'DELETE_PRODUCT',
                payload: productId
            });
        } catch (err) {
            dispatch({
                type: 'PRODUCT_ERROR',
                payload: err.response?.data?.msg || err.message || 'Ürün silinirken bir hata oluştu'
            });
            throw err;
        }
    };

    // Update Product
    const updateProduct = async product => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        try {
            const res = await axios.put(`/api/products/${product.product_id}`, product, config);

            dispatch({
                type: 'UPDATE_PRODUCT',
                payload: res.data
            });
            return res.data;
        } catch (err) {
            dispatch({
                type: 'PRODUCT_ERROR',
                payload: err.response?.data?.msg || err.message
            });
            throw err;
        }
    };

    // Reorder Products
    const reorderProducts = async (orderedIds) => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        try {
            await axios.post('/api/products/reorder', { ordered_ids: orderedIds }, config);
            return true;
        } catch (err) {
            dispatch({
                type: 'PRODUCT_ERROR',
                payload: err.response?.data?.msg || err.message || 'Sıralama güncellenemedi'
            });
            throw err;
        }
    };

    // Toggle Product Availability (Stock)
    const toggleAvailability = async productId => {
        try {
            const res = await axios.put(`/api/products/${productId}/toggle-availability`);
            
            dispatch({
                type: 'UPDATE_PRODUCT',
                payload: { product_id: productId, is_available: res.data.is_available }
            });
        } catch (err) {
            dispatch({
                type: 'PRODUCT_ERROR',
                payload: err.response?.data?.msg || err.message
            });
        }
    };

    // Get All Seller Products
    const getAllSellerProducts = async () => {
        try {
            const res = await axios.get('/api/products/seller/all');
            return res.data;
        } catch (err) {
            console.error('Tüm ürünler getirilemedi:', err);
            return [];
        }
    };

    return (
        <ProductContext.Provider
            value={{
                products: state.products,
                current: state.current,
                loading: state.loading,
                error: state.error,
                getProductsByMenu,
                addProduct,
                addProductToMenu,
                deleteProductFromMenu,
                deleteProductPermanently,
                updateProduct,
                reorderProducts,
                toggleAvailability,
                getAllSellerProducts
            }}
        >
            {props.children}
        </ProductContext.Provider>
    );
};

export default ProductState;
